import React, { useState } from "react";
import {UilSearch, UilMapMarker } from "@iconscout/react-unicons";
import { toast } from "react-toastify";

function Inputs({setQuery,units,setUnits }) {

  const [city,setCity] = useState('');

  const handleUnitsChange = (e) => {
    const selectedUnit = e.currentTarget.name;
    if (units !== selectedUnit) setUnits(selectedUnit);
  };

  const handleSearchClick = () => {
    if(city !=='')setQuery({q:city})
  }


  const handleLocationClick = () => {
    if (navigator.geolocation) {
      toast.info("Fetching users location.");
      navigator.geolocation.getCurrentPosition((position) => {
        toast.success("Location fetched!");
        let lat = position.coords.latitude;
        let lon = position.coords.longitude;

        setQuery({
          lat,
          lon,
        });
      });
    }
  }
  return (
    <div className="flex flex-row justify-center my-6">
      <div className="flex flex-row items-center justify-center space-x-4 w-3/4">
        <input
        value={city}
        onChange={(e) =>setCity(e.currentTarget.value)}
          type="text"
          placeholder="Search for city..."
          className="text-xl font-light p-2 w-full shadow-xl focus:outline-none rounded-md capitalize"
        />
        <UilSearch
          size={30}
          className="text-white cursor-pointer transform ease-out hover:scale-125 duration-200"
          onClick={handleSearchClick}
        />
        <UilMapMarker
          size={30}
          className="text-white cursor-pointer transform ease-out hover:scale-125 duration-200"
          onClick={handleLocationClick}
        />
      </div>

      <div className="flex flex-row justify-center items-center w-1/4">
        <button
          name="metric"
          className="text-xl text-white font-light transition ease-out hover:scale-125"
          onClick={handleUnitsChange}
        >
          °C
        </button>
        <p className="mx-1 text-xl text-white">|</p>
        <button
          name="imperial"
          className="text-xl text-white font-light transition ease-out hover:scale-125"
          onClick={handleUnitsChange}
        >
          °F
        </button>
      </div>
    </div>
  );
}

export default Inputs;
